/**
 * Format UUID for display - shows first 2 and last 4 characters
 * @param uuid - The UUID to format
 * @returns Formatted UUID string (e.g., "ab...1234") or "-" if empty
 */
export const formatUuid = (uuid: string | null | undefined): string => {
  if (!uuid) {
    return '-';
  }

  if (uuid.length < 6) {
    return uuid;
  }

  return `${uuid.slice(0, 2)}...${uuid.slice(-4)}`;
};
